import { z } from 'zod'

/*
  Similar to Summary Approval Messages, we want the option to allow a user to define:
  - a constant value
  - a mapping to a question in the form

  For text variables (might be expanded to adjacent variables like url), we want to allow a more complex string-templating
  system, where we can use the request context to fill in the values (exactly like Summary Approval Messages).

  For other types (like assignees), we want to allow a mapping to a question in the form, but we want to allow the user to define
  a specific value that it will be mapped to (maybe do this in the future).


  The simplest variation of this is:

  Data Variable = Single Text
  - String with variables (unresolved)

  Other Data Variables
  - Question ID of matching type (that can be coerced)
*/

const externalOperationInputMappingSourceSchema = z.enum(['static', 'form-field', 'request-context', 'composite', 'block-output'])
export type ExternalOperationInputMappingSource = z.infer<typeof externalOperationInputMappingSourceSchema>

const externalOperationInputSchema = z.object({
  source: externalOperationInputMappingSourceSchema,
  // TODO: Support the Variable Value schema
  value: z.string(),
  // Support for html strings in Quill
  rawValue: z.string().optional(),
  blockId: z.string().optional(),
  blockName: z.string().optional(),
  outputVariableId: z.string().optional(),
})

export const externalOperationInputMappingSchema = z.record(z.string(), externalOperationInputSchema)
export type ExternalOperationInputMapping = z.infer<typeof externalOperationInputMappingSchema>

export { isPropertyPickerMappingSource, propertyPickerMappingSources } from './externalOperationInputMappingSources'
export type { PropertyPickerMappingSource } from './externalOperationInputMappingSources'
